import { TENCENT_PARTNER_NAME } from '../../consts';

// Helper to get column value, using getValue if defined, otherwise direct field access
export const getColumnValue = (row, col) => (col.getValue ? col.getValue(row) : row[col.name]);

const TABLE_CONFIGS = {
    [TENCENT_PARTNER_NAME]: {
        showHeaderSeparators: true,
        columns: [
            {
                name: 'qqNumber',
                displayName: 'STATIC.PAGES.PARTNER_CONFIGURATION.USER_CONFIGURATION_SHELF.QQ_NUMBER_COLUMN',
                headerWidth: '40%',
                getValue: account => account.loginData?.[0]?.qqNumber?.toString(),
            },
            {
                name: 'loginId',
                displayName: 'STATIC.PAGES.PARTNER_CONFIGURATION.USER_CONFIGURATION_SHELF.ACCOUNT_ID_COLUMN',
                headerWidth: '15%',
            },
        ],
    },
};

const DEFAULT_CONFIG = {
    columns: [
        {
            name: 'loginId',
            displayName: 'STATIC.PAGES.PARTNER_CONFIGURATION.USER_CONFIGURATION_SHELF.EMAIL_COLUMN',
        },
    ],
};

export const getTableConfig = partnerName =>
    TABLE_CONFIGS[partnerName] ?? DEFAULT_CONFIG;
